import React from 'react';
import PropTypes from 'prop-types';

import Browser from '@wetransfer/concorde-browser';

import TransferLink from '@component/transfer-link';
import NotificationPositions from '@constant/notification-positions';
import VideoIllustration from '@component/illustration';

import I18n from '@module/i18n';

class Link extends React.PureComponent {
  state = {
    copied: false,
  };

  transferLink = React.createRef();

  onLinkCopied = (copied) => this.setState({ copied });

  onCopyLink = () => {
    if (this.transferLink.current) {
      this.transferLink.current.copyUrlToClipboard();
    }
  };
  render() {
    const { onRequestClose } = this.props;
    const contentText = Browser.isMobile
      ? 'transfer.complete_mobile.link_text'
      : 'transfer.complete_link.text';

    return (
      <React.Fragment>
        <div className="transfer__contents">
          <VideoIllustration
            type="transfer-complete-upload"
            src="transfer_window/transfer_completed"
            variants={3}
            className="uploader__image"
          />
          <h2>{I18n.t('transfer.complete_link.title')}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: I18n.t(contentText),
            }}
            className="complete__text"
          />
          <TransferLink
            notificationPosition={NotificationPositions.transfer}
            ref={this.transferLink}
            noButton
            onLinkCopied={this.onLinkCopied}
          />
        </div>
        <div className="transfer__footer">
          {this.state.copied || Browser.isTablet ? (
            <button className="transfer__button" onClick={onRequestClose}>
              {I18n.t('transfer.buttons.done')}
            </button>
          ) : (
            <button className="transfer__button" onClick={this.onCopyLink}>
              {I18n.t('transfer.buttons.copy_link')}
            </button>
          )}
        </div>
      </React.Fragment>
    );
  }
}

Link.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};

export default Link;
